var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('success',{attrs:{"title":_vm.title,"btn-list":_vm.btnData,"type":_vm.type,"show-middle-close-btn":true}},[(!_vm.exist)?_c('p',{staticClass:"result-hd"},[_vm._v("如需放行请点击下面“全部车辆”的按钮")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }